import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { DelegationEntity, FundWithDetailsEntity, ProtocolEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store/global';
import { showTokenGov_Amount_NotRounded } from '@/src/store/global/tokensStoreModelHelpers';
import styles from './DelegationStatus.module.scss';

interface DelegationStatusProps {
    fund: FundWithDetailsEntity;
    isDeposit: boolean;
    isLoadingDelegation: boolean;
    isLoadedDelegation: boolean;
    isTokensStoreReady: boolean;
    delegation?: DelegationEntity;
    protocol: ProtocolEntity;
    classNameStyle?: string;
    input_TokenGov: bigint;
}

export default function DelegationStatus(props: DelegationStatusProps) {
    //-----------------
    const { fund, isDeposit, isLoadingDelegation, isLoadedDelegation, isTokensStoreReady, delegation, protocol, classNameStyle, input_TokenGov } = props;
    //-----------------
    const tokensStore = useTokensStore();
    //-----------------
    return (
        <div className={`${styles.delegationSection} ${classNameStyle !== undefined ? styles[classNameStyle] : styles.dark}`}>
            {isLoadingDelegation === true || isLoadedDelegation === false ? (
                <>
                    <div className={styles.delegationItem}>
                        <div className={styles.text}>CURRENT STAKE</div>
                        <div className={styles.value}>
                            <LoaderButton />
                        </div>
                    </div>
                    <div className={styles.delegationItem}>
                        <div className={styles.text}>NEW STAKE</div>
                        <div className={styles.value}>
                            <LoaderButton />
                        </div>
                    </div>
                </>
            ) : delegation === undefined ? (
                <>
                    <div className={styles.delegationItem}>
                        <div className={styles.text}>CURRENT STAKE</div>
                        <div className={styles.value}>{showTokenGov_Amount_NotRounded(tokensStore, 0)}</div>
                    </div>
                    <div className={styles.delegationItem}>
                        <div className={styles.text}>NEW STAKE</div>
                        <div className={styles.value}>
                            {isDeposit === true ? showTokenGov_Amount_NotRounded(tokensStore, input_TokenGov) : showTokenGov_Amount_NotRounded(tokensStore, 0)}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.delegationItem}>
                        <div className={styles.text}>CURRENT STAKE</div>
                        <div className={styles.value}>{showTokenGov_Amount_NotRounded(tokensStore, delegation.ddStaked)}</div>
                    </div>
                    <div className={styles.delegationItem}>
                        <div className={styles.text}>NEW STAKE</div>
                        <div className={styles.value}>
                            {isDeposit === true
                                ? showTokenGov_Amount_NotRounded(tokensStore, delegation.ddStaked + input_TokenGov)
                                : showTokenGov_Amount_NotRounded(tokensStore, input_TokenGov >= delegation.ddStaked ? 0n : delegation.ddStaked - input_TokenGov)}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
